export default class DownloadService {
	constructor(apiService) {
		this.apiService = apiService
	}

	isWebdavConfigured() {
		return this.apiService.callGet('me/downloads/is_webdav_configured')
	}

	getDownloads() {
		return this.apiService.callGet('me/downloads')
	}

	getFullRouteForFileDownload() {
		return this.apiService.host + 'me/download_file/'
	}

	getFullRouteForFilesDownload() {
		return this.apiService.host + 'me/download_files/'
	}

	downloadFiles(params) {
		return this.apiService.callPost('me/download_files', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/DownloadService.js